<template>
  <Transition>
    <div
      v-if="active"
      class="fixed bottom-[24px] right-[24px] flex items-center bg-white border border-[#D9D9D9] p-[9px] h-[44px] rounded-[5px] font-[570] text-[12px] text-[#070707]"
    >
      <div class="flex mr-[7px] items-center justify-center w-[24px] h-[24px]">
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.0583 9.31523L14.7506 8.6229C16.2697 7.10379 16.2697 4.64081 14.7506 3.1217V3.1217C13.2315 1.60258 10.7685 1.60258 9.2494 3.1217L8.55707 3.81402M9.77788 13.5956L9.08556 14.2879C7.56644 15.8071 5.10347 15.8071 3.58435 14.2879V14.2879C2.06523 12.7688 2.06523 10.3059 3.58435 8.78674L4.27668 8.09442"
            stroke="#A6A6A6"
            stroke-width="1.64219"
            stroke-linecap="round"
          />
          <path
            d="M11.7732 6.09961L6.56228 11.3105"
            stroke="#A6A6A6"
            stroke-width="1.64219"
            stroke-linecap="round"
          />
        </svg>
      </div>
      <p>URL copied to your clipboard</p>
      <button
        class="flex items-center justify-center w-[26px] h-[26px] ml-[57px] bg-[#F6F6F6] rounded-[3px]"
        @click.prevent="$emit('close')"
      >
        <svg
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 1L0.999999 6.99869"
            stroke="#070707"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7 7L1 1.00131"
            stroke="#070707"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, toRef, watch } from "vue";

const props = defineProps<{
  show: boolean;
}>();

defineEmits<{
  (e: "close"): void;
}>();

const active = ref(false);
const timeout = ref<NodeJS.Timeout | number | undefined>(undefined);
watch(toRef(props, "show"), (value) => {
  active.value = value;
});

watch(active, (value) => {
  if (timeout.value != null) {
    clearTimeout(timeout.value);
    timeout.value = undefined;
  }

  if (value === true) {
    timeout.value = setTimeout(() => {
      active.value = false;
    }, 10000);
  }
});
</script>

<style scoped>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.3s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
